import axios from 'axios';
import { CURRENT_API_URL } from "../../Utils/Constants";
import notify from '../../Notifications/ToastifyActions';


function UpdateAllAsinSkusTaskService(token, data) {
    
    // id in productDetails is either a field called asin or a field called integerId
    return axios.post(`${CURRENT_API_URL}/sellerPartner/UpdateAllAsinSKUTask`, data, {
        
        headers: {
            'Authorization': token,
        }
    }).then( notify.NotifySuccess("Skus are getting updated."))      
        .then(res => {
            notify.NotifySuccess("Skus have been saved in DB.")
            return res.data;
        }).catch(() => {
            notify.NotifyError("An error occurred while updating Skus.");
            return false;
        });
}

export {
    UpdateAllAsinSkusTaskService,
}